import React from 'react';

const SparkSolid = ({ width = 26, height = 26, color = '#DFCDFA', ...rest }) => {
  return (
    <svg {...rest} width={width} height={width} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 14C11.875 14 14 11.949 14 7C14 11.949 16.11 14 21 14C16.11 14 14 16.11 14 21C14 16.11 11.875 14 7 14ZM1 5.5C4.134 5.5 5.5 4.182 5.5 1C5.5 4.182 6.857 5.5 10 5.5C6.857 5.5 5.5 6.857 5.5 10C5.5 6.857 4.134 5.5 1 5.5Z"
        fill={color}
        stroke={color}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default SparkSolid;
